import {
  Bridge,
  BridgeAction,
  BridgePayload,
  BridgePayloadMap,
} from "./Bridge";
import { Logger } from "../utils/Logger";

export class AndroidBridge extends Bridge {
  readonly platform = "android";

  protected postMessage(action: BridgeAction, payload?: BridgePayload) {
    if (typeof window === "undefined") {
      Logger.error("window is undefined", {
        tags: { from: "AndroidBridge.postMessage" },
      });
      return;
    }

    if (!window.BluxAndroid?.postMessage) {
      Logger.error("No Android WebView available", {
        tags: { from: "AndroidBridge.postMessage" },
      });
      return;
    }

    window.BluxAndroid.postMessage(JSON.stringify({ action, payload }));
  }

  initialize(payload: BridgePayloadMap["initialize"]) {
    this.postMessage("initialize", payload);
  }

  signIn(payload: BridgePayloadMap["signIn"]) {
    this.postMessage("signIn", payload);
  }

  signOut() {
    this.postMessage("signOut");
  }

  setUserProperties(payload: BridgePayloadMap["setUserProperties"]) {
    this.postMessage("setUserProperties", payload);
  }

  setCustomUserProperties(
    payload: BridgePayloadMap["setCustomUserProperties"],
  ) {
    this.postMessage("setCustomUserProperties", payload);
  }

  sendEvent(payload: BridgePayloadMap["sendEvent"]) {
    this.postMessage("sendEvent", payload);
  }
}
